import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { FormattedMessage } from "gatsby-plugin-intl"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

import Hero from "../../components/hero"
import Demo from "../../components/demo"

import Backup from "../../images/icons/backup.svg";
import ControlAccess from "../../images/icons/control-access.svg";
import Certs from "../../images/icons/certs.svg";
import CampaignSafety from "../../images/icons/campaign-safety.svg";

class IndexPage extends Component {
  reveal () {
    const ScrollReveal = require('scrollreveal').default

    ScrollReveal({
      viewFactor: 0.4,
      distance: '100px',
      duration: 1000
    });

    ScrollReveal().reveal('.sr-1', {
      delay: 0
    });

    ScrollReveal().reveal('.sr-2', {
      delay: 100
    });

    ScrollReveal().reveal('.sr-r', {
      origin: 'right'
    });

    ScrollReveal().reveal('.sr-b', {
      origin: 'bottom'
    });
  }

  componentDidMount () {
    if (typeof window !== 'undefined') {
      this.reveal();
    }
  }

  render () {
    return (
      <Layout>
        <SEO title="Безопасность" description="Безопасность — развивайте бизнес, используя автоматизацию многоканального маркетинга, основанную на данных. Побеждайте конкурентов!" />
        <Hero title="Безопасность" subtitle="Что делает нас надежным партнером?" />

        <div className="container container--pad mar-t-6 mar-b-6">
          <div className="section-h pad-t-3 sr-hidden sr-1">
            <div className="parallax parallax--circle" />
            <h2 className="section-h__2 mar-b-2">
              <FormattedMessage id="security.h_1" />
            </h2>
          </div>
            
          <div className="columns is-variable is-4 mar-t-6">
            <div className="column sr-hidden sr-1">
              <div className="section-h section-h--full section-h--small">
                <Backup style={{width: `100px`, height: `100px`}} />
                <h2 className="section-h__2 mar-t-2 mar-b-2">
                  <FormattedMessage id="security.h_2" />
                </h2>
                <p className="section-h__3">
                  <FormattedMessage id="security.t_2" />
                </p>
              </div>
            </div>
            <div className="column sr-hidden sr-2">
              <div className="section-h section-h--full section-h--small">
                <ControlAccess style={{width: `100px`, height: `100px`}} />
                <h2 className="section-h__2 mar-t-2 mar-b-2">
                  <FormattedMessage id="security.h_3" />
                </h2>
                <p className="section-h__3">
                  <FormattedMessage id="security.t_3" />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container container--pad pad-t-3 mar-t-6 mar-b-6">
          <div className="columns is-variable is-4">
            <div className="column sr-hidden sr-1">
              <div className="section-h section-h--full section-h--small">
                <Certs style={{width: `100px`, height: `100px`}} />
                <h2 className="section-h__2 mar-t-2 mar-b-2">
                  <FormattedMessage id="security.h_4" />
                </h2>
                <p className="section-h__3 mar-b-2">
                  <FormattedMessage id="security.t_4" />
                </p>
                <Link to="/why-expertsender/gdpr-and-iso-27001" className="arrow-link">
                  <FormattedMessage id="security.b_4" />
                </Link>
              </div>
            </div>
            <div className="column sr-hidden sr-2">
              <div className="section-h section-h--full section-h--small">
                <CampaignSafety />
                <h2 className="section-h__2 mar-t-2 mar-b-2">
                  <FormattedMessage id="security.h_5" />
                </h2>
                <p className="section-h__3">
                  <FormattedMessage id="security.t_5" />
                </p>
              </div>
            </div>
          </div>
        </div>

        <Demo props={this.props.data} />
      </Layout>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query {
    photo1: file(relativePath: { eq: "why-us/values/photo-1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 540, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    photo2: file(relativePath: { eq: "why-us/values/photo-2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 540, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    photo3: file(relativePath: { eq: "why-us/values/photo-3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 540, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    photo4: file(relativePath: { eq: "why-us/values/photo-4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 540, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    esDashboard: file(relativePath: { eq: "expertsender-dashboard.png" }) {
      childImageSharp {
        fluid(maxWidth: 1260, quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
